import React, { useContext } from 'react';

import { Select } from 'antd';

import { ListContext } from '@contexts/ListContext';

const Option = Select.Option;

const ModelInvoiceTypeSelector = ({ value, onChange, disabled, emptyValue }) => {
    const { cachedList } = useContext(ListContext);
    const modelInvoiceTypes = cachedList.taxmethods.items.ModelInvoiceTypes || [];

    return (
        <Select
            autoComplete="off"
            value={value || ''}
            onChange={onChange}
            disabled={disabled}
            style={{ width: '100%' }}
        >
            {emptyValue && <Option value="">All Invoice Types</Option>}
            {modelInvoiceTypes.map((el, key) => (
                <Option key={key} value={el.Code}>
                    {el.Code} - {el.Name}
                </Option>
            ))}
        </Select>
    );
};

export default ModelInvoiceTypeSelector;
